import React from "react";
import { NumericFormat } from "react-number-format";
import { Box, Divider, Tooltip, Typography } from "@mui/material";
import { ProductAvailabilityCode } from "../../../../shared/models/customerBuyerStockItemsModels";
import StockItemDetailsAvailability from "../../../../inventory/components/StockItemDetailsAvailability";
import ImageBox from "../../../../../shared/components/ImageBox";
import DataBlock from "../../../../../shared/components/dataBlocks/DataBlock";
import { ChangeOffer, CustomerSentOffersState } from "../../../models/models";
import { useAppSelector } from "../../../../../shared/hooks/sharedHooks";

interface StockItemDetailsMainProps {
  offer: ChangeOffer;
  className: string;
}

const StockItemDetailsMain = ({ offer, className }: StockItemDetailsMainProps) => {
  const { manufacturers, categories } = useAppSelector<CustomerSentOffersState>(
    (state: any) => state.customerSentOffers
  );
  return (
    <Box className="mt-2">
      <Divider></Divider>

      <Box className="mt-2">
        <StockItemDetailsAvailability availabilityCode={offer?.availabilityCode || ProductAvailabilityCode.inStock} />
      </Box>

      <Box className="flex justify-between mt-4 gap-4">
        <Typography fontSize={14} fontWeight={500} className="text-14-medium uppercase" style={{ color: "#333" }}>
          {manufacturers.find((x) => x.id === offer.manufacturerId)?.name}
        </Typography>

        <Typography fontSize={12} fontWeight={500} className="text-12-medium text-right">
          {categories.find((x) => x.id === offer.categoryId)?.name}
        </Typography>
      </Box>

      <Box className="flex w-full justify-between mt-1 gap-4">
        <Box className="flex flex-col justify-between">
          <Box>
            <Tooltip title={offer.productNumber.length > 25 ? offer.productNumber : null} placement="top">
              <Box className="text-14-medium ellipsis-hidden" color={"#333333"} sx={{ width: "190px" }}>
                {offer.productNumber}
              </Box>
            </Tooltip>

            <Tooltip
              title={
                offer.productAlternativeNumber && offer.productAlternativeNumber.length > 25
                  ? offer.productAlternativeNumber
                  : null
              }
              placement="top"
            >
              <Box className="text-14-medium ellipsis-hidden" sx={{ width: "190px" }}>
                {offer.productAlternativeNumber}
              </Box>
            </Tooltip>
          </Box>

          <Box>
            <Typography fontSize={20} fontWeight={600} className="text-20-bold">
              <NumericFormat value={offer?.unitPrice?.toString()} displayType="text" thousandSeparator=" " suffix="€" />
            </Typography>
            <Typography fontSize={14} fontWeight={400} className="text-14-regular">
              + shipping
            </Typography>
          </Box>
        </Box>

        <Box>
          <ImageBox size="medium" src={offer?.imageFile?.content} />
        </Box>
      </Box>

      <DataBlock className="text-12-medium mt-4" title="Description" value={offer?.description} />
    </Box>
  );
};

export default StockItemDetailsMain;
